import { useQuery } from '@tanstack/react-query';

import { artiaProtectedApi } from '@/lib/api-client';

type ZipCodeLookupResult = {
  zipCode: string;
  city: string;
  stateCode: string;
  county: string;
};

const lookupZipCode = async (zipCode: string): Promise<ZipCodeLookupResult> => {
  return await artiaProtectedApi.get(`lookups/zip-codes/${zipCode}`);
};

export const useZipCodeLookup = (zipCode: string | undefined) => {
  const isValidZipCode = zipCode?.length === 5 && /^\d{5}$/.test(zipCode);

  return useQuery({
    queryKey: ['zipCodeLookup', zipCode],
    queryFn: () => lookupZipCode(zipCode!),
    enabled: isValidZipCode,
    staleTime: 1000 * 60 * 60 * 24 * 30, // Cache for 30 days - zip codes rarely change
    gcTime: 1000 * 60 * 60 * 24 * 30, // Keep in cache for 30 days
    retry: false,
  });
};
